import React from "react";
import { useFormik } from "formik";
import axios from "axios";
import { useNavigate } from "react-router-dom"; 

const Login = () => {
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validate: values => {
            const errors = {};
            if (!values.email) {
                errors.email = "Email is Required";
            }
            if (!values.password) {
                errors.password = "Password is Required";
            }
            return errors;
        },
        onSubmit: async values => {
            try {
                const response = await axios.post(
                    "https://manncarriers.com/server/login.php",
                    // "http://localhost:8080/mann/login.php",
                    {
                        email: values.email,
                        password: values.password
                    },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

                console.log("Login Response:", response.data);

                if (response.data.success == true) {
                    
                    localStorage.setItem("isLogin", "true");
                    navigate("/adminhome");
                    
                } else {
                    alert(response.data.message || "Login failed.");
                }
            } catch (error) {
                console.error("Login error:", error);
                alert("Something went wrong during login.");
            }
        }
    });

    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image2.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
            </div>
            <div className="containerLog">
                <div className="LogInBox" data-aos="fade-up" data-aos-delay="200">
                    <h1 className="mb-4 text-uppercase fw-bolder">Login</h1>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="mb-4 ">
                            <label className="d-block font-semibold">Email</label>
                            <div className="inputBox">
                                <input
                                    className="p-2 form-control"
                                    type="email"
                                    name="email"
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                />
                                {formik.errors.email && (
                                    <div className="small text-danger mt-2">{formik.errors.email}</div>
                                )}
                            </div>
                        </div>

                        <div className="mb-5">
                            <label className="d-block font-semibold">Password</label>
                            <div className="inputBox">
                                <input
                                    className="p-2 form-control"
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                />
                                {formik.errors.password && (
                                    <div className="small text-danger mt-2">{formik.errors.password}</div>
                                )}
                            </div>
                        </div>

                        <button type="submit" className="logButton " >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;
